module.exports = __webpack_public_path__ + "media/images/icon__link-cf2d8db88f0948b8f49bdcf96e8b4061.png";